export default {"src":"/_next/static/media/menu.0e79da6c.svg","height":385,"width":385};